@import '../../theme/global.scss';

:host {
  background: $gray-100;
  color: $gray-800;
  display: flex;
  flex-flow: column;
  font-size: 1rem;
  line-height: 1.5rem;
  padding: 0.75rem 1rem;
  text-align: left;
  @include set-font;
  @include box-sizing;

  .wrapper {
    align-items: center;
    display: flex;
  }

  h3 {
    color: $gray-500;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    margin: 0;
    padding: 0;
    text-transform: capitalize;

    @media (min-width: map-get($breakpoints, 'md')) {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
  }

  .description {
    color: $gray-800;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (min-width: map-get($breakpoints, 'md')) {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
  }

  .switch-profile-link {
    margin-top: 0.25rem;
  }

  .avatar {
    height: 2.5rem;
    margin-right: 0.5rem;
    width: 2.5rem;

    img {
      border-radius: 50%;
      object-fit: cover;
      width: 100%;
    }
  }
}
